module.exports = __webpack_public_path__ + "img/sweet-spot-header-copy@3x.465383f2.png";